import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UserManagementService } from '../user-management.service';
import Swal from 'sweetalert2';
import { ForgotpassconfirmComponent } from "../forgotpass-confirm/forgotpass-confirm.component"
import { ModalService } from "src/app/service/modal.service";

@Component({
    selector: 'app-forgotpass',
    templateUrl: './forgotpass.component.html',
    styleUrls: ['./forgotpass.component.css'],
    standalone: false
})
export class ForgotpassComponent implements OnInit {
  forgotpassForm: FormGroup;
  hidePassword = true;
  hideConfirmPassword = true;
  captchaText: any = [];
  captchaEntered: String = "";
  validCaptcha: boolean = false;
  userCaptcha: string = ''; 
  noiseImage: string = '';

  constructor(private fb: FormBuilder,private userService: UserManagementService,private activeModal: NgbActiveModal,private mservice: ModalService) {}

  ngOnInit() {
    this.forgotpassForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      captcha: ["", [Validators.minLength(5)]],
    });
    this.generateCaptcha();
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('password')?.value === g.get('confirmPassword')?.value
      ? null : { 'mismatch': true };
  }

  getErrorMessage(controlName: string): string {
    const control = this.forgotpassForm.get(controlName);
    if (control?.hasError('required')) {
      return `${controlName.charAt(0).toUpperCase() + controlName.slice(1)} is required`;
    }
    return '';
  }

 
  validateCaptcha(captcha: any) {
    const expectedCaptcha = this.captchaText.map(item => item.char).join('');
    this.validCaptcha = captcha.trim() === expectedCaptcha;
  }  
  
  refreshCaptcha(event?: Event): void {
    this.generateCaptcha(event);
  }
  
  generateCaptcha(event?: Event): void {
    if (event) {
      const button = (event.target as HTMLElement).closest('.refresh-button');
      if (button) {
        button.classList.add('rotating');
        setTimeout(() => button.classList.remove('rotating'), 1000); // Reset animation
      }
    }
  
    const possibleCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890!@#$%^&*';
    const captchaLength = 5;
  
    this.captchaText = this.generateCaptchaText(captchaLength, possibleCharacters);
    this.noiseImage = this.addBackgroundNoise();
    this.userCaptcha = ''; 
    this.validCaptcha = false; 
  }
  
  generateCaptchaText(length: number, characters: string): { char: string; style: any }[] {
    return Array.from({ length }, () => {
      const randomChar = this.makeRandom(1, characters);
      const styles = {
        fontSize: `${Math.floor(Math.random() * 23) + 18}px`,
        color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
        transform: `rotate(${Math.random() * 30 - 15}deg) translate(${Math.random() * 10 - 5}px, ${Math.random() * 10 - 5}px)`,
        fontWeight: Math.random() > 0.7 ? 'bold' : 'normal',
        fontStyle: Math.random() > 0.8 ? 'italic' : 'normal',
        textShadow: `${Math.floor(Math.random() * 5)}px ${Math.floor(Math.random() * 6)}px ${Math.floor(Math.random() * 6)}px rgba(0, 0, 0, 0.3)`,
        opacity: (Math.random() * 0.3 + 0.7).toFixed(2)
      };
  
      return { char: randomChar, style: styles };
    });
  }
  
  makeRandom(length: number, characters: string): string {
    return Array.from({ length }, () =>
      characters.charAt(Math.floor(Math.random() * characters.length))
    ).join('');
  }
  
  addBackgroundNoise(): string {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 200;
    canvas.height = 40;
  
    if (ctx) {
      for (let i = 0; i < 20; i++) {
        ctx.strokeStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.5)`;
        ctx.beginPath();
        ctx.moveTo(Math.random() * 200, Math.random() * 40);
        ctx.lineTo(Math.random() * 200, Math.random() * 40);
        ctx.stroke();
      }
  
      for (let i = 0; i < 10; i++) {
        ctx.fillStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.5)`;
        ctx.beginPath();
        ctx.arc(Math.random() * 200, Math.random() * 40, Math.random() * 5, 0, 2 * Math.PI);
        ctx.fill();
      }
    }
  
    return canvas.toDataURL();
  }
  
  onPaste(event: ClipboardEvent): void {
    event.preventDefault(); 
  }


  onSubmit() {
    if (this.forgotpassForm.valid) {
      let request={
          username:this.forgotpassForm.value.username
        }
        
        this.userService.forgotpass(request).then((response: any) => {
          if (response && response.status == 1) {
            this.activeModal.dismiss();
            this.openForgotpassConfirmModal(this.forgotpassForm.value.username);
          }
      })

    } else {
      Object.keys(this.forgotpassForm.controls).forEach(key => {
        const control = this.forgotpassForm.get(key);
        if (control?.invalid) {
          control.markAsTouched();
        }
      });
    }
  }
  showAlert(msg) {
    Swal.fire({
      title: msg,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    });
  }
  private openForgotpassConfirmModal(username) {
    const modalRef = this.mservice.open(ForgotpassconfirmComponent, {
      options: {
        backdrop: false,
        keyboard: true,
      }
    });
    modalRef.componentInstance.username = username
    
  }
  public dissmissModal() {
    this.activeModal.dismiss();
  }
}